import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { WIZ_EVENT_TYPE, WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import {WizComponentManager,
  WizHgroup,
  WizPopUp,
  WizRoot,
  WizEventManager, WizEvent, WizTranslationManager, COMPONENTRESOURCES
} from '@wizeoo/akm-component-lib';
import { VisionStep, WidgetConfigurationObj } from '@wizeoo/akm-message-lib';
import { ClipboardService } from 'ngx-clipboard';
import { BaselineEngine, WizConstants } from '@wizeoo/akm-compute-lib';


import { CalendarWidget } from './calendar/calendar.widget';
import { ChartWidget } from './chart/chart.widget';
import { WidgetDataPopDatas, IFreedataWidget, IWidget } from '../../manager/widgets/i-widget';
import { FormWidget } from './form/form.widget';
import { FreedataCalendarWidget } from './freedatacalendar/freedata-calendar.widget';
import { FreedataFormWidget } from './freedataform/freedata-form.widget';
import { FreedataWidgetDataPop } from './freedatas/pops/freedata-widget-data.pop';
import { ListWidget } from './list/list.widget';
import { ChartsEngine } from '../../manager/charts/charts.engine';
import { ALK_EVENT_TYPE, WIDGET_ACTION_ORIGIN, WIDGET_GLOBAL_KIND, WIDGET_KIND, WIDGET_STATE } from '../../model/enums';
import { ViewData } from '../../model/view.data';
import { AlkEvent } from '../../framework/events/alk.event';
import { GridsterWidget } from '../../vo/workingzone/gridster-widget';
import { PhysicalTemplateVO } from '../../vo/workingzone/physical-template.vo';
import { ScenarioVO } from '../../vo/scenarii/scenario.vo';
import { StyleEngine } from '../../manager/workingdata/style.engine';
import { TabVO } from '../../vo/workingzone/tab.vo';
import { getDefaultWidgetConfigurationObj } from '../../manager/widgets/widget.engine';
import { PermissionAccess, StaticFeatureEnum, PermissionVisibility } from '../../manager/permission/permissions.types';
import { GlobalFilter } from './globalfilter/global-filter.component';
import { FreedataTimelineWidget } from './freedatatimeline/freedata-timeline.widget';
import { TimelineWidget } from './timeline/timeline.widget';
import { FreeFormWidget } from './freeform/free-form.widget';
import { FreedataTileWidget } from './tiles/freedata-tile.widget';
import { CtxtEntry } from '../../manager/context/user-context.service';
import { TileWidget } from './tiles/tile.widget';
import { ConnectVO } from '../../vo/core/connect.vo';
import { Pivot } from './pivot/pivot.component';
import { FreedataGridWidget } from './freedatas/freedatagrid.widget';
import { ConnectButton } from '../../manager/core/connectrenderers/connect-button';

import { WidgetDataPop } from './widgetpops/widget-data.pop';
import { WidgetDisplayRights, WidgetDisplayRightsPop } from './widgetpops/widget-display-rights.pop';
import { WidgetDisplaySettings, WidgetDisplaySettingsPop } from './widgetpops/widget-display-settings.pop';
import { WidgetScenarioPop, WidgetScenarioPopDatas } from './widgetpops/widget-scenario.pop';
import { WidgetDisplayConnectPop } from './widgetpops/widget-display-connect.pop';
import { Model } from '../../model/model';
import { GeneratorWidget } from './generator/generator.widget';
import { GeneratorDataPop } from './widgetpops/generator-data.pop';

/**
 * Composant de rendu d'un Widget
 */
@Component({
  selector: 'widget-comp',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetComponent implements AfterViewInit, OnDestroy {
  
  public EXCEL: any = COMPONENTRESOURCES.EXCEL;
  public PDF: any = COMPONENTRESOURCES.PDF;

  @HostListener('drop', ['$event']) public onDrop(evt) { // drop excel
    evt.preventDefault();
    evt.stopPropagation();
    const files = evt.dataTransfer.files;
     this.model.excelExportEngine.readExcelFile(this.currentWidget, files[0]);
  }
  
   /** masqué */
  @HostBinding('class.invisible-class') get isHidden(): boolean {
    let res: boolean = false;
    if(!(this.gridsterConfig?.rows > 3) && !this.hasBorders()) {
      res = true;
    }
    return res;
  }

  @Input() public model: Model;

  /** prevent, sinon le navigateur prend le contrôle */
  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    // console.log('dragover');
  }
  
  
  // container HTML pour chargement des fonctions conditionnées
  @ViewChild('widgetContainer', { read: ViewContainerRef, static: true }) widgetContainer: ViewContainerRef;
  @ViewChild('idxZone', { read: WizHgroup, static: true }) idxZone: WizHgroup;
  @ViewChild('idxSubZone', { read: WizHgroup, static: true }) idxSubZone: WizHgroup;
  
  /** activation de la drop de choix des scenars */
  public useScen(): boolean {
    let visionPart: boolean = !! this.model.currentVision?.useScenario;
    let widgetPart: boolean = this.widgetConfig?.scenOn; // pas de conf sur drop d'un nouveau widget
    return visionPart && widgetPart;
  }

  /**
   * retourne le scenario en cours, soit issu du template, soit overridé par les params users
   * soit param global
   */
  public get scenario(): string {
    let scenKey:string = null; // ViewData.DEFAULT_SCENARIO;
    
    // pas d'activation, on bascule sur main ou sur celui du globalFilter s'il est unique
    if(!this.widgetConfig?.scenOn ) { 
      // on bascule sur celui du globalFilter s'il est unique, sinon c'est MAIN
      if( this.model.widgetEngine.globalScenarii?.size === 1) {
        scenKey  = [... this.model.widgetEngine.globalScenarii.values()][0];
      } else {
        scenKey = ViewData.DEFAULT_SCENARIO;
      }
      return scenKey;
    }

    // mode multiple, on utilise le mot clé
    if(!!this.widgetConfig?.scenX ) { 
      scenKey = ViewData.SCEN_KEY_CODE;
      return scenKey;
    }


    // j'ai un code scenar, je le prends
    if(!!this.widgetConfig?.scenCode) {
      scenKey = this.widgetConfig.scenCode;
    } else { // sinon c'est main
      scenKey = ViewData.DEFAULT_SCENARIO;
    }

    // pas en mode template et modif de scenar possible par user
    if (!this.templatingMode && !!this.widgetConfig?.scenUM) { 
      // uniquement si modifications user autorisées
      const contextEntry: CtxtEntry = {... this.model.userContextService.getWidget(ViewData.currentTab?.featureCode, this.currentWidget?.uid)};
      let userContext: WidgetConfigurationObj = {...contextEntry?.data}; // contexte utilisateur
      if(!!userContext?.scenCode) {
        scenKey = userContext.scenCode;
      }
    }

    // on contrôle que le scenar existe (j'ai pu le supprimer)
    if(scenKey !== ViewData.DEFAULT_SCENARIO) {
      let exit: ScenarioVO =  this.model.scenarioEngine.getScenario( this.model.currentVision.code, scenKey);
      if(!exit) {
        scenKey = ViewData.DEFAULT_SCENARIO;
      }
    }
    
    return scenKey;
  }

  /** libellé du scénario en cours */
  public get scenColor(): string {
    let result: string = '';
    let key: string = this.scenario;
    if(!!key) {
      let selectSen:ScenarioVO =  this.model.scenarioEngine.getScenario(this.widgetConfig?.v, key);
      if(!!selectSen) {
        result = selectSen.color;
      }
    }
    return result;
  }

  /** libellé du scénario en cours */
  public get scenLabel(): string {
    let result: string = '';
    if(!!this.widgetConfig?.scenOn && !!this.widgetConfig?.scenX) { 
      result = WizTranslationManager.getInstance().translateKey('$.scen.concurrent.$');
    } else {
      let key: string = this.scenario;
      if(key === WizConstants.BASE_SCENARIO) {
        result = WizTranslationManager.getInstance().translateKey('$.scen.main.$');
      } else if(!!key) {
        let selectSen:ScenarioVO =  this.model.scenarioEngine.getScenario(this.widgetConfig?.v, key);
        if(!!selectSen) {
          result = selectSen.trsLabel;
        }
      }
    }

    return result;
  }

  /**
   * affichage du libellé du scenario (sauf si main)
   */
  public get showScenLabel(): boolean {
    if(this.widgetConfig?.k === WIDGET_KIND.GLOBAL_FILTER) { // pas de mode scenar sur le globalFilter
      return false;
    }

    if(this.widgetConfig?.scenX) { // label mode multi-scenar
      return true;
    }

    if(!this.widgetConfig?.scenOn && this.scenario !== WizConstants.BASE_SCENARIO) { // on a un override par le globalFilter...
      return true;
    } else {
      let useScenPart: boolean = this.useScen();
      let confPart: boolean = this.widgetConfig?.scenLbl; // on veut l'affichage
      return useScenPart && confPart;
    }
  }

  /**
   * affichage de l'icone de gestion des scenarii
   */
  public get showScenIcon(): boolean {
    
    // if(this.widgetConfig?.k === WIDGET_KIND.GLOBAL_FILTER) { // pas de mode scenar sur le globalFilter
    //   return false;
    // }

    
    if(this.widgetConfig?.scenX) { // pas de choix en mode multi-scenar
      return false;
    }

    let useScenPart: boolean = this.useScen();
    let scenPart: boolean = true; // this.widgetConfig?.scenCode !== ViewData.DEFAULT_SCENARIO; // pas d'affichage si c'est le scen MAIN
    let userPart: boolean = this.configureEnable || this.widgetConfig?.scenUM; // mode templating ou autorisation pour users
    // console.log('showScenIcon', useScenPart , scenPart , userPart);
    return useScenPart && scenPart && userPart;
  }

  public currentWidget: IWidget = null; // le widget actif, sélectionné sur le setType
  private currentComponentWidget: ComponentRef<IWidget>; // le widget encapsulé dans son wrapper Html

  public dataSourcePopClassFactory: any = null; // le type de popUp pour la configuration de la DS

  private componentMap: Map<string, ComponentRef<IWidget>> = new Map<string, ComponentRef<IWidget>>(); // la map des composants déjà créer pour éviter un build systématique

  private currentStep: VisionStep;

  private 

  // objet capsule de configuration: toute la structure Gridster, le titre, la conf globale.
  // Il contient widget.wco, qui correspond à widgetConfig (la conf fonctionnelle du compo)
  private _gridsterConfig: GridsterWidget;

  @Input()
  public set gridsterConfig(value: GridsterWidget) {
    this._gridsterConfig = value;
    if (!!value.wco) {
      this.autoSelect(); // déjà une conf
    }
  }
  public get gridsterConfig(): GridsterWidget {
    return this._gridsterConfig;
  }

  // accesseur sur la configuration du widget : ses données fonctionnelles
  private get widgetConfig(): WidgetConfigurationObj {
    return !!this.gridsterConfig ? this.gridsterConfig.wco : null;
  }

  // les enum de type pour alimentation des boutons de création
  public gridType: WIDGET_KIND = WIDGET_KIND.GRID;
  public chartType: WIDGET_KIND = WIDGET_KIND.CHART;
  public listType: WIDGET_KIND = WIDGET_KIND.LIST;
  public pivotType: WIDGET_KIND = WIDGET_KIND.PIVOT;
  public formType: WIDGET_KIND = WIDGET_KIND.FORM;
  public calendarType: WIDGET_KIND = WIDGET_KIND.CALENDAR;
  public timelineType: WIDGET_KIND = WIDGET_KIND.TIMELINE;
  public tileType: WIDGET_KIND = WIDGET_KIND.TILE;

  public fdGridType: WIDGET_KIND = WIDGET_KIND.FD_GRID;
  public fdFormType: WIDGET_KIND = WIDGET_KIND.FD_FORM;
  public fdCalendarType: WIDGET_KIND = WIDGET_KIND.FD_CALENDAR;
  public fdTimelineType: WIDGET_KIND = WIDGET_KIND.FD_TIMELINE;
  public fdTileType: WIDGET_KIND = WIDGET_KIND.FD_TILE;



  public freeFormType: WIDGET_KIND = WIDGET_KIND.FREE_FORM;
  public globalFilterType: WIDGET_KIND = WIDGET_KIND.GLOBAL_FILTER;
  public generatorType: WIDGET_KIND = WIDGET_KIND.GENERATOR;
  
  @Input() templatingMode: boolean = false;

  /** référence à l'objet maître, soit un template, soit un TabVO (pour rendu dans le tabVO) */
  private _itemParent: PhysicalTemplateVO | TabVO;
  @Input() public set itemParent(value: PhysicalTemplateVO | TabVO) {
    this._itemParent = value;
  }
  public get itemParent(): PhysicalTemplateVO | TabVO {
    return this._itemParent;
  }

  /** La configuration de la donnée est autorisée et il existe un type de widget  */
  private _dataEnable: boolean = true;
  @Input() public set dataEnable(value: boolean) {
    this._dataEnable = value;
    this.cdref.markForCheck();
  }
  public get dataEnable(): boolean {
    return this.widgetConfig?.k === WIDGET_KIND.FREE_FORM || (this._dataEnable && !!this.widgetConfig && !!this.widgetConfig.k);
  }

  /** La configuration est autorisée, données + type de widget + alimentation du step sur le widget */
  private _configureEnable: boolean = true;
  @Input() public set configureEnable(value: boolean) {
    this._configureEnable = value;
    this.cdref.markForCheck();
  }
  public get configureEnable(): boolean {
    const result = (
      this._configureEnable &&
      this.dataEnable &&
      !!this.widgetConfig.v && // la vision est définie
      (!!this.widgetConfig.vs || !!this.widgetConfig.fdk || this.widgetConfig?.k === WIDGET_KIND.FREE_FORM) // un step ou un FD
    ); // plus un step ou un step relatif
    return result;
  }

  /** Possibilité de supprimer le widget ou non  */
  private _trashEnable: boolean = true;
  @Input() public set trashEnable(value: boolean) {
    this._trashEnable = value;
    this.cdref.markForCheck();
  }
  public get trashEnable(): boolean {
    return this._trashEnable;
  }

  /**
   * Construction dynamique du titre du widget en fonction de son étape de configuration
   */
  public get title(): string {
    return this.gridsterConfig?.title || this.getDefaultTitle();
  }


  public get rowHeight(): number {
    return this.gridsterConfig?.rowHeight || ViewData.defaultRowHeight;
  }

  public get headerHeight(): number {
    return this.gridsterConfig?.headerHeight || ViewData.defaultHeaderHeight;
  }


  /** affichage de la zone d'entête */
  public hasBorders():boolean {
    if(this.configureEnable) {
      return true;
    }
    return !this.gridsterConfig?.hideBorders;
  }

  /** masquer toute la bordure pour les charts */
  // public noBorderChart():boolean {
  //   let noBorder: boolean = !this.hasBorders();
  //   let isChart: boolean = this.currentWidget?.widgetKind === WIDGET_KIND.CHART;
  //   let isFree: boolean = this.currentWidget?.widgetKind === WIDGET_KIND.FREE_FORM; // aussi pour les freeForms
  //   return noBorder && (isChart || isFree);
  // }

  /** 
   * masquer toute la bordure si rien à afficher
   * false = visible
   */
  public noBorderToutCourt():boolean {
    let result: boolean = false;
    let noBorder: boolean = !this.hasBorders();
    let isChart: boolean = this.currentWidget?.widgetKind === WIDGET_KIND.CHART;
    let isFree: boolean = this.currentWidget?.widgetKind === WIDGET_KIND.FREE_FORM; // aussi pour les freeForms
    

    if(isChart) {
      result = noBorder && !this.templatingMode;
    } else if(isFree) {
      result = !this.exportEnablePDF2 && !this.templatingMode;
      // console.log(result, this.templatingMode, this.configureEnable);
    }  else {
      result = noBorder && !this.showScenIcon && 
      !this.exportEnableXLS2 && 
      !this.exportEnablePDF2 && 
      !this.massDeleteEnabled && 
      !(this.settingsEnable && this.canUpdateTemplates);
    }
    // console.log('noBorderToutCourt', result);
    return result;
  }


  /** Couleur de la font du header */
  public get fontColor(): string {
    return this.gridsterConfig?.fontColor || StyleEngine.STYLE_DEFAULT_FONT_COLOR;
  }

  /** Couleur du background du header */
  public get backgroundColor(): string {
    if(this.gridsterConfig?.backgroundColor) {
      return this.gridsterConfig?.backgroundColor
    } else {
      // if( this.model.currentVision?.color) {
      //   return  this.model.currentVision?.color;
      // } else {
        return StyleEngine.STYLE_DEFAULT_BACKGROUND_COLOR;
      // }
    }
  }

  /** Couleur du background du widget */
  public get widgetBackgroundColor(): string {
    if(this.gridsterConfig?.widgetBackgroundColor) {
      return this.gridsterConfig?.widgetBackgroundColor
    } else {
        return StyleEngine.STYLE_DEFAULT_WIDGET_BACKGROUND_COLOR;
    }
  }

  /** Couleur du background du widget */
  public get radius(): string {  
    let res: string = '0';
    if(this.gridsterConfig?.radius) {
      res = this.gridsterConfig.radius.toString();
    } 
    // console.log('cornerRadius', this.gridsterConfig?.radius);
    return res+'px';
  }


  /** Couleur des icônes du header */
  public get iconColor(): string {
    return this.gridsterConfig?.iconColor || StyleEngine.STYLE_DEFAULT_ICON_COLOR;
  }

  /** Couleur de bordure */
  public get borderColor(): string {
    return this.gridsterConfig?.borderColor || StyleEngine.STYLE_DEFAULT_WIDGET_BACKGROUND_COLOR;
  }

  /** Couleur des icônes FD */
  public get fdIconColor(): string {
    return StyleEngine.STYLE_DEFAULT_FD_ICON_COLOR;
  }

  /** Couleur des icônes FD */
  public get globalconColor(): string {
    return StyleEngine.STYLE_DEFAULT_GLOBAL_ICON_COLOR;
  }

  /** Construction dynamique de l'indice du widget pour affichage des parents */
  public get indice(): string {
    if (!!this.gridsterConfig && !!this.gridsterConfig.indice) {
      return this.gridsterConfig.indice.toString();
    }
    return '';
  }

  /**
   * affichage de l'indice du maître
   */
  public get masterIndices(): string[] {
    if (!!this.gridsterConfig && !!this.gridsterConfig.masterUid) {
      if(this.widgetConfig?.k === WIDGET_KIND.GENERATOR) { // gestion du cas particulier "generator"
        let splitted: string[] = this.gridsterConfig.masterUid.split(ViewData.KEY_SEPARATOR);
        let toLive: Set<string> = new Set();
        let toDie: Set<string> = new Set();
        let indices: string[] = [];
        
        splitted.forEach(s => {
          let gw: GridsterWidget = this.model.widgetEngine.getWidgetByUid(s);
          if(!!gw) {
            toLive.add(s);
            indices.push(gw.indice.toString());
          } else {
            toDie.add(s);
          }
        });

        if(toDie.size > 0) {
          this.widgetConfig.muid = toLive.size > 0 ? [...toLive.keys()].join(ViewData.KEY_SEPARATOR) : null;
          this.synchronizeWco(this.widgetConfig);
        }
        return indices;

      } else { // tous les widgets sauf le generator
        if (!!this.gridsterConfig.masterVO) {
          return [this.gridsterConfig.masterVO.indice.toString()];
        } else {
          this.widgetConfig.muid = null;
          this.synchronizeWco(this.widgetConfig);
        }
      }
      
      
      // if (!!this.gridsterConfig.masterVO) {
      //   return this.gridsterConfig.masterVO.indice.toString();
      // } else {
      //   // le master n'existe plus, suppression
      //   if (!!this.widgetConfig) {
      //     if(this.widgetConfig.k === WIDGET_KIND.GENERATOR) {// pas pour les generators, indices multiples
      //       // console.log('oups do no kill me');
      //     } else {
      //       this.widgetConfig.muid = null;
      //     }
      //   }
         
      //   this.synchronizeWco(this.widgetConfig);
      // }
    }
    return null;
  }

  /** La configuration est autorisée, données + type de widget + alimentation du step sur le widget */
  private _settingsEnable: boolean = true;
  @Input() public set settingsEnable(value: boolean) {
    this._settingsEnable = value;
    this.cdref.markForCheck();
  }
  public get settingsEnable(): boolean {
    // pas en mode configuration
    return this.currentWidget && this._settingsEnable && !this.configureEnable; // plus un step ou un step relatif
  }

  public get setSettingsEnable(): boolean {
    // configuration de l'accès aux settings
    return this.currentWidget && this._settingsEnable;
  }

  /**
   * autoriser la suppression en masse pour les FDVs
   */
  public get massDeleteEnabled(): boolean {
    return this.currentWidget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.FREEDATA && !!this.widgetConfig?.massDel;
  }



  /** affichage de la popUp de gestion des accès (édition, configuration) */
  public setRights(): void {
    const displayRights: WidgetDisplayRights = {
      widget: this.currentWidget,
      editionAllowed: this.widgetConfig.eda,
      headerMassEdit: this.widgetConfig.hme,
      settingsAllowed: this.widgetConfig.sa,
      showFilters: this.widgetConfig.showF,

      showList: this.widgetConfig.showR,
      showAdd: this.widgetConfig.showC,
      showDelete: this.widgetConfig.showD,
      gatlingMode: this.widgetConfig.gatling,

      useScenarii: this.widgetConfig.scenOn,
      multipleScenarii: this.widgetConfig.scenX,
      userShowScenarii: this.widgetConfig.scenUM,
      showScenLabel: this.widgetConfig.scenLbl,
      excelCreate: this.widgetConfig.xlsC,
      excelUpdate: this.widgetConfig.xlsU,
      excelSheet: this.widgetConfig.xlsSheet,
      excelNonUniqueShortCode: this.widgetConfig.xlsNusc,
      massDel: this.widgetConfig.massDel,
      noUserFilter: this.widgetConfig.noUserFilter,
      expPDF: this.widgetConfig.expPDF, // export Excel interdit 
      expXLS: this.widgetConfig.expXLS, // export PDF interdit
      hidden: this.widgetConfig.hidden,
      targetPlace: this.widgetConfig.targetPlace
    };

    const pop: WizPopUp = new WizPopUp(
      WidgetDisplayRightsPop,
      true,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      WidgetDisplayRightsPop.popWidth,
      WidgetDisplayRightsPop.popHeight,
      displayRights
    );
    pop.setCallback((wdr: WidgetDisplayRights) => {
      
      let scenXDelta: boolean = false; // indicateur pour forcer le refresh des scenars
      if(this.widgetConfig.scenOn !== wdr.useScenarii) { // activation ou pas du mode scenar
        scenXDelta = true;
      }

      if(this.widgetConfig.scenX !== wdr.multipleScenarii) { // passage du mode single au mode multi
        scenXDelta = true;
      }
      
      this.widgetConfig.sa = wdr.settingsAllowed;
      this.widgetConfig.eda = wdr.editionAllowed;
      this.widgetConfig.hme = wdr.headerMassEdit;
      this.widgetConfig.showF = wdr.showFilters;

      this.widgetConfig.showR = wdr.showList;
      this.widgetConfig.showC = wdr.showAdd;
      this.widgetConfig.showD = wdr.showDelete;
      this.widgetConfig.gatling = wdr.gatlingMode;

      this.widgetConfig.scenOn = wdr.useScenarii;
      this.widgetConfig.xlsC = wdr.excelCreate;
      this.widgetConfig.xlsU = wdr.excelUpdate;
      this.widgetConfig.xlsSheet = wdr.excelSheet || null;
      this.widgetConfig.xlsNusc = wdr.excelNonUniqueShortCode;
      this.widgetConfig.scenX = wdr.multipleScenarii;
      this.widgetConfig.scenUM = wdr.userShowScenarii;
      this.widgetConfig.scenLbl = wdr.showScenLabel;
      this.widgetConfig.massDel = wdr.massDel;
      this.widgetConfig.noUserFilter = wdr.noUserFilter;
      this.widgetConfig.expPDF = wdr.expPDF;
      this.widgetConfig.expXLS = wdr.expXLS;
      this.widgetConfig.hidden = wdr.hidden;
      this.widgetConfig.targetPlace = wdr.targetPlace;

      this.synchronizeWco(this.widgetConfig);

      // this.manageScenDS(); // gestion éventuelle de la drop des scenarii
      ViewData.wizUpdateModel = true;
      this.cdref.markForCheck();

      if(scenXDelta) {
        this.forceWidgetData(null); // mise à jour du pool de données, changement de portée scenar
      }

      this.currentWidget?.rightsUpdate(this.widgetConfig);

    });
    pop.show();


  }

  /** L'export est autorisé' */
  private _exportEnableXLS: boolean = true;
  @Input() public set exportEnableXLS(value: boolean) {
    this._exportEnableXLS = value;
    this.cdref.markForCheck();
  }
  public get exportEnableXLS(): boolean {
    // pas en mode configuration
    return this.currentWidget && this._exportEnableXLS; //  && !this.configureEnable; 
  }
  public get exportEnableXLS2(): boolean { // prise en compte de la conf de la pop
    return this.exportEnableXLS && !this.widgetConfig.expXLS; 
  }


  private _exportEnablePDF: boolean = true;
  @Input() public set exportEnablePDF(value: boolean) {
    this._exportEnablePDF = value;
    this.cdref.markForCheck();
  }
  public get exportEnablePDF(): boolean {
    // pas en mode configuration
    return this.currentWidget && this._exportEnablePDF; //  && !this.configureEnable; 
  }
  public get exportEnablePDF2(): boolean { // prise en compte de la conf de la pop
    return this.exportEnablePDF && !this.widgetConfig.expPDF; 
  }


  /* ################################################
              interactions externes
     ################################################ */

  constructor(public elementRef: ElementRef, private cdref: ChangeDetectorRef, private _clipboardService: ClipboardService) {}

  ngAfterViewInit() {
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.WIDGET_CHANGE_SEQUENCE, this.refreshSequence); // modification de l'indice sur delete
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.RESET_MASTER, this.resetMaster); //le maitre est devenu incohérent
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.WIDGET_MUST_REFRESH, this.forceWidgetData); //retour d'appel connect, refresh global
    
    // WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.APPLY_SCENARIO, this.onScenChanged); //changement de scenario
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.GLOBAL_SCENAR_UPDATE, this.onGlobalScenChanged); //changement de scenario
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.DELETE_SCENARIO, this.checkOnDeleteScenarii); //retour d'appel connect, refresh global
    
    WizEventManager.addListener(this, this, ALK_EVENT_TYPE.WIDGET_CONNECT_CALL, this.connectCall); //appel connect
  }

  ngOnDestroy() {
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.WIDGET_CHANGE_SEQUENCE);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.RESET_MASTER);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.WIDGET_MUST_REFRESH); //retour d'appel connect, refresh global

    // WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.APPLY_SCENARIO); //changement de scenario
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.GLOBAL_SCENAR_UPDATE); //changement de scenario
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.DELETE_SCENARIO);
    
    WizEventManager.removeListener(this, this, ALK_EVENT_TYPE.WIDGET_CONNECT_CALL); //appel connect
  }

  /* ################################################
              cycle de vie
     ################################################ */

  /** le widget est asservi à un autre widget */
  public hasLegacy(): boolean {
    return !!this.widgetConfig && !!this.widgetConfig.muid;
  }

  /** refresh de l'indice et de l'indice parent éventuel */
  private refreshSequence(e: AlkEvent = null): void {
    this.cdref.markForCheck();
  }

  /** il existe déjà une configuration */
  private autoSelect(): void {
    // sélection et alimentation du step
    this.buildPhysical(false);
  }

  /** ### étape 1, chox du type - Clic sur un des icones pour le choix du type de widget */
  public setType(pType: WIDGET_KIND): void {
    if (!this.widgetConfig) {
      // pas encore de conf, on la crée
      this.gridsterConfig.wco = getDefaultWidgetConfigurationObj();
      this.gridsterConfig.wco.v =  this.model.visionCode;
    }
    this.gridsterConfig.wco.k = pType.toString();
    if (  pType === WIDGET_KIND.GRID 
          || pType === WIDGET_KIND.FORM 
          || pType === WIDGET_KIND.CALENDAR
          || pType === WIDGET_KIND.TILE
          || pType === WIDGET_KIND.TIMELINE
          || pType === WIDGET_KIND.FREE_FORM 
          || pType === WIDGET_KIND.GLOBAL_FILTER
          || pType === WIDGET_KIND.GENERATOR) {
      
      this.gridsterConfig.wco.pm = false; // les widgets en data flat
    } else {
      this.gridsterConfig.wco.pm = true;
    }

    if (pType === WIDGET_KIND.CHART) {
      // alimentation du type de chart par défaut
      this.gridsterConfig.wco.ct = ChartsEngine.defaultChartType;
    }

    if (this.dataEnable) {
      // le descripteur de widget est cohérent
      this.configureDataPool(); // alimentation des données
    }

    if (pType === WIDGET_KIND.GLOBAL_FILTER) { // filtre global, mode multiScen forcé
      this.gridsterConfig.wco.eda = false;
      this.gridsterConfig.wco.scenOn = true;
      this.gridsterConfig.wco.scenX = true;
      this.gridsterConfig.wco.scenLbl = false;
      this.gridsterConfig.wco.scenCode = ViewData.SCEN_KEY_CODE;
    }
  }

  /** ### étape 2
   * popUp de configuration du périmètre de données
   * Accès direct possible par l'icone "data"
   */
  public configureDataPool(): void {
    if(this.widgetConfig.k === WIDGET_KIND.FREE_FORM || this.widgetConfig.k === WIDGET_KIND.GLOBAL_FILTER) { // freeForm & globalFilter, pas de DS
      this.onDataPoolFeeded(this.widgetConfig, true);
      return;
    } else if (  
      this.widgetConfig.k === WIDGET_KIND.FD_GRID 
          || this.widgetConfig.k === WIDGET_KIND.FD_FORM 
          || this.widgetConfig.k === WIDGET_KIND.FD_CALENDAR
          || this.widgetConfig.k === WIDGET_KIND.FD_TIMELINE
          || this.widgetConfig.k === WIDGET_KIND.FD_TILE
          ) {
      this.dataSourcePopClassFactory = FreedataWidgetDataPop; // DS pour les Freedatas
    } else if(this.widgetConfig.k === WIDGET_KIND.GENERATOR) {
      this.dataSourcePopClassFactory = GeneratorDataPop; // DS du générateur de cartésien
    } else {
      this.dataSourcePopClassFactory = WidgetDataPop; // DS de baselines
    }

    let params: WidgetDataPopDatas = {model : this.model, config: this.widgetConfig, gridsterConfig: this.gridsterConfig};

    const pop: WizPopUp = new WizPopUp(
      this.dataSourcePopClassFactory,
      true,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      this.dataSourcePopClassFactory.width,
      this.dataSourcePopClassFactory.height,
      params
    );
    pop.setCallback(this.onDataPoolFeeded.bind(this));
    pop.show();
  }

  /** Edition du périmètre de données, le contexte est alimenté avec le périmètre de données (par la popUp) */
  private onDataPoolFeeded(wco: WidgetConfigurationObj, followWithConf: boolean = true) {
    // this.widgetGridsterConfig.wco = wco;
    this.synchronizeWco(wco);

    // contrôle de la cohérence des widgets asservis
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.CHECK_SLAVE_INTEGRITY, this.gridsterConfig));

    // WizEventManager.dispatchEvent(this, new WizEvent(WIZ_EVENT_TYPE.CHANGE, null, this.widgetGridsterConfig)); // mise à jour de la source dans templating
    this.buildPhysical(followWithConf); // on passe à la construction physique
  }

  /** alimentation de la vue Html avec le bon composant */
  private buildPhysical(followWithConf: boolean = true): void {
    this.widgetContainer.clear();

    this.currentComponentWidget = this.feedWidgetComponent(this.widgetConfig.k);

    this.currentWidget = this.currentComponentWidget ? this.currentComponentWidget.instance : null;

    this.buildConnect(); // construction éventuelle des fonctions connect

    // prise de la configuration par user
    // console.log('sa', this.currentWidget.code, this.widgetConfig.sa);
    if (!!this.widgetConfig.sa) {
      this.settingsEnable = this.widgetConfig.sa;
    } else {
      this.settingsEnable = false;
    }

    this.cdref.markForCheck(); // on attend qu'il soit instancié
    setTimeout(() => {
      // console.log('set widget set listener', this.currentWidget);
      WizEventManager.addListener(
        this,
        this.currentWidget.elementRef,
        ALK_EVENT_TYPE.WIDGET_SET_SETTINGS,
        this.backFromSettings
      );
      this.setWidgetData(followWithConf);
    }, 0);
  }

  /** forcer le changement de configuration, sur fonction connect ou sur changement de scenario (local ou global) */
  private forceWidgetData(e: AlkEvent): void {
    this.currentWidget.state = WIDGET_STATE.INIT; // on reinit le widget
    this.setWidgetData(false);
  }

  /**
   * ### étape 3, on alimente le composant avec le pool de données cible
   * @param followWithConf: va ouvrir la popUp de conf (création du composant)
   */
  private setWidgetData(followWithConf: boolean = true): void {
    if (!!this.widgetConfig.vs) { // niveau absolu, prise du step
      this.currentStep = BaselineEngine.getVisionStepByLevel( this.model.currentVision, this.widgetConfig.vs);
    } else {
      this.currentStep = null; // rien trouvé, bad settings ou widget de type FD
    }

    if (followWithConf) { // on pose un écouteur sur le widget, pour détecter que ses données sont OK
      WizEventManager.addListener(
        this,
        WizRoot.root(),
        ALK_EVENT_TYPE.WIDGET_READY,
        this.backFromDatas
      );
    }

    // alimentation de la datasource
    // console.log('widgetCompo setDS', this.widgetConfig.k, this.scenario);
    this.currentWidget.setDatasource( this.model.currentVision, this.currentStep, this.scenario, this.widgetConfig);

    this.cdref.markForCheck();
  }

  /** retour d'alimentation en données, passage à la configuration */
  private backFromDatas(e: AlkEvent): void {
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.WIDGET_READY);
    // console.log('wid backFromDatas', wid);
    this.showSettingsPop();
  }

  /**
   * ### étape 4, choix de la configuration du composant.
   * Aussi accessible par l'icone "settings"
   */
  public showSettingsPop(): void {
    // WizEventManager.addListener(this, this.currentWidget.elementRef, ALK_EVENT_TYPE.WIDGET_SET_SETTINGS, this.backFromSettings);
    this.currentWidget.showSettingsPop();
  }

  /**
   * bouton d'export des données
   */
  public exportDatas(kind?: string): void {
    this.currentWidget.exportDatas(kind);
  }

  /** retour de configuration, on met à jour le wco */
  private backFromSettings(e: AlkEvent): void {
    // console.log('wid backFromSettings', this.indice, e.data);
    this.synchronizeWco(e.data.settings);
  }

  /**
   * le master est devenu inconséquent, reset
   * @param e AlkEvent.RESET_MASTER
   */
  private resetMaster(e: AlkEvent): void {
    // console.log('widget reset Master', e.value);
    this.refreshSequence();
  }

  /**
   * mise à jour du wco depuis les altérations du composant
   * @param widWco la conf du compo
   */
  private synchronizeWco(widWco: WidgetConfigurationObj): void {
    this.gridsterConfig.wco = widWco; // et surtout lui, transmis à gridster 
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.WIDGET_CONFIG_UPDATE, this.gridsterConfig));
  }

  /**
   * retourne un widget avec ses paramètres de configuration par défaut. Va le chercher dans la map si existe déjà
   * @param kind: WIDGET_KIND
   * @return ComponentRef<IWidget>
   */
  public feedWidgetComponent(kind: string): ComponentRef<IWidget> {
    if (this.componentMap.has(kind)) {
      // déjà créé
      return this.componentMap.get(kind);
    } else {
      // création du code unique du compo (tabTemplate + uid) TODO, modifier avec onglet de TAB sur "convertir en onglet"
      // const widCode: string = this.itemParent.code + ViewData.KEY_SEPARATOR + this.widgetGridsterConfig.uid;
      const widCode: string = this.gridsterConfig.uid;
      this.gridsterConfig.code = widCode; // alimentation du code sur la conf AllkeyGridItem
      let widgetClass: any = null; // classe du widget
      let widgetPivotMode: boolean = true; // mode pivot

      switch (kind) {
        case WIDGET_KIND.GRID:
          widgetClass = Pivot;
          widgetPivotMode = false;
          break;
        case WIDGET_KIND.PIVOT:
          widgetClass = Pivot;
          widgetPivotMode = true;
          break;
        case WIDGET_KIND.LIST:
          widgetClass = ListWidget;
          widgetPivotMode = true;
          break;
        case WIDGET_KIND.CHART:
          widgetClass = ChartWidget;
          widgetPivotMode = true;
          this.exportEnableXLS = false;
          this.exportEnablePDF = true;
          break;
        case WIDGET_KIND.FORM:
          widgetClass = FormWidget;
          widgetPivotMode = false;
          this.exportEnableXLS = false;
          this.exportEnablePDF = true;
          break;
        case WIDGET_KIND.TILE:
          widgetClass = TileWidget;
          widgetPivotMode = false;
          this.exportEnableXLS = false;
          this.exportEnablePDF = true;
          break;
        case WIDGET_KIND.CALENDAR:
          widgetClass = CalendarWidget;
          widgetPivotMode = false;
          this.exportEnableXLS = false;
          this.exportEnablePDF = false;
          break;
        case WIDGET_KIND.TIMELINE:
          widgetClass = TimelineWidget;
          widgetPivotMode = false;
          this.exportEnableXLS = false;
          this.exportEnablePDF = false;
          break;
        case WIDGET_KIND.FD_GRID:
          widgetClass = FreedataGridWidget;
          widgetPivotMode = false;
          break;
        case WIDGET_KIND.FD_FORM:
          widgetClass = FreedataFormWidget;
          widgetPivotMode = false;
          this.exportEnableXLS = false;
          this.exportEnablePDF = true;
          break;
        case WIDGET_KIND.FD_CALENDAR:
          widgetClass = FreedataCalendarWidget;
          widgetPivotMode = false;
          this.exportEnableXLS = false;
          this.exportEnablePDF = false;
          break;
        case WIDGET_KIND.FD_TIMELINE:
          widgetClass = FreedataTimelineWidget;
          widgetPivotMode = false;
          this.exportEnableXLS = false;
          this.exportEnablePDF = false;
          break;
        case WIDGET_KIND.FD_TILE:
          widgetClass = FreedataTileWidget;
          widgetPivotMode = false;
          this.exportEnableXLS = false;
          this.exportEnablePDF = true;
          break;
        case WIDGET_KIND.GLOBAL_FILTER:
          widgetClass = GlobalFilter;
          widgetPivotMode = false;
          this.exportEnableXLS = false;
          this.exportEnablePDF = false;
          break;
        case WIDGET_KIND.FREE_FORM:
          widgetClass = FreeFormWidget;
          widgetPivotMode = false;
          this.exportEnableXLS = false;
          this.exportEnablePDF = true;
          break;
        case WIDGET_KIND.GENERATOR:
          widgetClass = GeneratorWidget;
          widgetPivotMode = false;
          this.exportEnableXLS = false;
          this.exportEnablePDF = false;
          break;
      }

      return WizComponentManager.instance.addChildTo(widgetClass, this.widgetContainer, {
        instanceProperties: {
          uid: widCode,
          model:  this.model,
          pivotMode: widgetPivotMode,
          showSetting: !this.templatingMode,
          settings: this.widgetConfig,
          templatingMode: this.templatingMode,
        },
      });
    }
  }

  /** Demande de suppression du widget */
  public remove(): void {
    WizEventManager.dispatchEvent(this, new WizEvent(WIZ_EVENT_TYPE.DELETE, null, this.gridsterConfig));
  }

  /** Demande d'édition des display settings (title, colors) */
  public setDisplaySettings(): void {
    const displaySettings: WidgetDisplaySettings = {
      title: this.title,
      rowHeight: this.rowHeight,
      headerHeight: this.headerHeight,
      fontColor: this.gridsterConfig.fontColor,
      iconColor: this.gridsterConfig.iconColor,
      backgroundColor: this.gridsterConfig.backgroundColor,
      hideBorders:this.gridsterConfig.hideBorders,
      radius: this.gridsterConfig.radius,
      borderColor: this.gridsterConfig.borderColor,
      widgetBackgroundColor: this.gridsterConfig.widgetBackgroundColor,
      fontColorH: this.gridsterConfig.fontColorH,
      backgroundColorH: this.gridsterConfig.backgroundColorH,
      widget: this.currentWidget
    };
    const pop: WizPopUp = new WizPopUp(
      WidgetDisplaySettingsPop,
      true,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      WidgetDisplaySettingsPop.baseWidth +'px',
      WidgetDisplaySettingsPop.baseHeight +'px',
      displaySettings
    );
    pop.setCallback((wds: WidgetDisplaySettings) => {
      this.gridsterConfig.title = wds.title;
      this.gridsterConfig.rowHeight = wds.rowHeight;
      this.gridsterConfig.headerHeight = wds.headerHeight;
      this.gridsterConfig.fontColor = wds.fontColor;
      this.gridsterConfig.iconColor = wds.iconColor;
      this.gridsterConfig.backgroundColor = wds.backgroundColor;
      this.gridsterConfig.widgetBackgroundColor = wds.widgetBackgroundColor;
      this.gridsterConfig.hideBorders = wds.hideBorders;
      this.gridsterConfig.radius = wds.radius;
      this.gridsterConfig.borderColor = wds.borderColor;
      this.gridsterConfig.fontColorH = wds.fontColorH;
      this.gridsterConfig.backgroundColorH = wds.backgroundColorH;

      // console.log('radius : ', this.gridsterConfig.radius);
      ViewData.wizUpdateModel = true;
      this.currentWidget?.drawOrRefresh(WIDGET_ACTION_ORIGIN.CONFIGURE); // forcer le refresh des couleurs sur les types grid
      this.cdref.markForCheck();
    });
    pop.show();
  }

  /** alimentation du titre par défaut sur choix */
  public getDefaultTitle(): string {
    return  this.model.widgetEngine.getDefaultTitle(this.widgetConfig);
  }


  /**
   * le widget possède t-il une DS (pas les freeForms)
   */
  public get hasDS(): boolean {
    return this.widgetConfig?.k !== WIDGET_KIND.FREE_FORM && this.widgetConfig?.k !== WIDGET_KIND.GLOBAL_FILTER;
  }

  /**
   * L'utilisateur a-t-il les droits pour modifier les templates ?
   */
  public get canUpdateTemplates(): boolean {
    return  this.model.permissionEngine.hasAnyPermission({
      accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
      feature: StaticFeatureEnum.TEMPLATE,
      visibility: PermissionVisibility.DISABLED
    });
  }

  /**
   * popUp de configuration des scenarii
   */
  public chooseScen(): void {

    let params:  WidgetScenarioPopDatas = {
      model: this.model,
      config: this.widgetConfig,
      gridsterConfig: this.gridsterConfig,
      scenarioCode: this.scenario
    }

    const pop: WizPopUp = new WizPopUp(
      WidgetScenarioPop,
      true,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      WidgetScenarioPop.width,
      WidgetScenarioPop.height,
      params
    );
    pop.setCallback(this.onScenarioFeeded.bind(this));
    pop.show();
  }

  /** Edition du scenario */
  private onScenarioFeeded(wco: WidgetConfigurationObj) {
    this.synchronizeWco(wco);
    
    if(this.templatingMode) {
      ViewData.wizUpdateModel = true;
    } else {
      // console.log('update users Scen', wco, this.templatingMode);
       this.model.userContextService.saveWidget(this.currentWidget.uid, ViewData.currentTab?.featureCode, this.gridsterConfig.wco);
    }   

    this.forceWidgetData(null); // mise à jour du pool de données
    this.cdref.markForCheck(); // refresh visuel
  }

  /**
   * modification du scenario global
   * @param e 
   */
  private onGlobalScenChanged(e: AlkEvent): void {
    
    if(this.widgetConfig.k !== WIDGET_KIND.GLOBAL_FILTER) {
      this.forceWidgetData(null);
    }
  }

  public copyWidget(): void {
    if(this.templatingMode) {   
      WizEventManager.dispatchEvent(this.currentWidget, new AlkEvent(ALK_EVENT_TYPE.CLONE_WIDGET_REQUEST, this.gridsterConfig));           
      ViewData.widgetCopy = this.gridsterConfig;
    }
  }

  private checkOnDeleteScenarii(e: AlkEvent): void {
    // console.log('checkOnDeleteScenarii', e);
       
    let deadScens: ScenarioVO[] = e.data;
    // on enlève les scenars de la pile globale (globalFilter)
    deadScens.forEach((scen: ScenarioVO) => {
       this.model.widgetEngine.globalScenarii.delete(scen.code);
    });
   
    this.forceWidgetData(e);
  }

  /* ##############################################################################
          Gestion de la suppression en masse pour les widgets de type FD
     ############################################################################## */

  /**
   * demande de suppression en masse des données sélectionnées du widget
   */
  public deleteDatas(): void {
    // dispatch de l'event de suppression en masse pour le widget
    WizEventManager.dispatchEvent(this.currentWidget, new AlkEvent(ALK_EVENT_TYPE.MASS_DELETE_REQUEST, this.gridsterConfig));
  }

  /* ##############################################################################
          Gestiondes fonctions connect au niveau du widget
     ############################################################################## */

  // zone d'ajout des champs connect
  @ViewChild('containerConnect', { read: ViewContainerRef, static: true }) containerConnect: ViewContainerRef;

  /** à minima 1 fonction connect */
  get hasConnect(): boolean {
    return this.widgetConfig?.cnx?.length > 0;
  }

  /**
   * ouverture de la popUp de choix des fonctions connect pour alimentation du widget
   */
  public setConnect(): void {
    const pop: WizPopUp = new WizPopUp(
      WidgetDisplayConnectPop,
      true,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      WidgetDisplayConnectPop.width,
      WidgetDisplayConnectPop.height,
      this.currentWidget
    );
    pop.setCallback(this.onConnectFeeded.bind(this));
    pop.show();
  }

  /**
   * retour de popUp des fonctions connect, alimentation de la barre
   * et persistence de la conf
   * @param cnx 
   */
  private onConnectFeeded(cnx: ConnectVO[]): void {
    // enregistrement dans le contexte
    let result: string[] = null;
    if(cnx.length > 0) {
      result = [];
      cnx.forEach(cn => {
        result.push(cn.code);
      });
    }

    this.widgetConfig.cnx = result;
    this.synchronizeWco(this.widgetConfig);
    
    if(this.templatingMode) {
      ViewData.wizUpdateModel = true;
    } else {
       this.model.userContextService.saveWidget(this.currentWidget.uid, ViewData.currentTab?.featureCode, this.gridsterConfig.wco);
    }   

    // construction des fonctions connect
    this.buildConnect();
  }

  /** suppression de la zone connect */
  private clearConnect(): void {
    this.containerConnect?.clear(); // vider le container
  }

  /** construction des fonctions connect */
  protected buildConnect() {
    this.clearConnect(); // on rince tout
    // construire unique le rendu, pas besoin d'alimenter les collections tant que la drop n'est pas ouverte
    if(this.widgetConfig?.cnx?.length > 0) {
      this.widgetConfig.cnx.forEach((cnxStr: string) => {
        let cnx: ConnectVO =  this.model.connectEngine.getConnect(cnxStr);
        if(cnx) {
          const meCompo: ComponentRef<any> = WizComponentManager.instance.addChildTo(ConnectButton, this.containerConnect, {
            instanceProperties: { data: cnx, widget: this.currentWidget },
            styleProperties: { height: '25px', width: '25px'},
          });
        }
      });
    }

    this.cdref.markForCheck(); // refresh visuel
  }
  
  /**
   * appel d'une fonction connect depuis les boutons ConnectButton
   * @param e 
   */
  private connectCall(e: AlkEvent): void {
    let cnx: ConnectVO = e.data;
    let pool: any[] = null;
    if(this.currentWidget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE) {
      pool = this.currentWidget.mainDS.selectedItems || null;
    } else if(this.currentWidget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.FREEDATA) {
      pool = (this.currentWidget as IFreedataWidget).fdvDS.selectedItems || null;
    }
     this.model.connectEngine.doArgActionExt(cnx?.code, this.currentWidget, pool);
  }

}
